import Box from 'components/shared/Box'
import Icon from 'components/shared/Icon'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import { useResolutions } from 'store/resolutions'
import { useApp } from 'store/steps'
import { CustomMonthPromoProps } from 'components/shared/Calendar/components/CustomMonth'

const PERCENT_DISCOUNTS_BY_MONTHS = [
    25, 25, 50, 40, 40, 40, 30, 30, 60, 60, 30, 30,
]

export const BlackWeekendCalendar = ({
    monthIndex,
    monthName,
}: Omit<CustomMonthPromoProps, 'year'>) => {
    const { language } = useApp()
    const { isTablet } = useResolutions()
    const monthNameLettercased =
        language === 'en' ? monthName : monthName.toLowerCase()

    return (
        <Box
            direction="row"
            isFullWidth
            minWidth={[0, 432]}
            justify={['center', 'flex-end']}
            mt={[24, 0]}
            mb={2}
            gap={8}
        >
            {!isTablet && <Icon variant="ticket-2" color="primary_500" />}
            <Text
                variant={language === 'en' ? 'bodySmall' : 'body'}
                color="primary_500"
                hasNoWrap
            >
                <FormattedMessage
                    id="promo.black_weekend.calendar_discount_info"
                    defaultMessage="W Black Weekend <strong>{discount}%</strong> zniżki na {month}!"
                    values={{
                        discount: PERCENT_DISCOUNTS_BY_MONTHS[monthIndex],
                        month: monthNameLettercased,
                        strong: (chunks: string[]) => (
                            <Text
                                as="span"
                                variant="heading5"
                                color="grayscale_200"
                            >
                                {chunks}
                            </Text>
                        ),
                    }}
                />
            </Text>
        </Box>
    )
}
